import { X, SlidersHorizontal } from "lucide-react";

const ChipGroup = ({ label, options, value, onChange, testid }) => (
  <div data-testid={testid}>
    <div className="label-mono luma-muted mb-2">{label}</div>
    <div className="flex flex-wrap gap-1.5">
      {options.map((opt) => {
        const active = value === opt;
        return (
          <button key={opt} type="button"
            data-testid={`${testid}-${opt}`}
            onClick={() => onChange(active ? "" : opt)}
            className={`chip ${active ? "chip-active" : "chip-outline"}`}>
            {opt}
          </button>
        );
      })}
    </div>
  </div>
);

const Toggle = ({ label, active, onClick, testid }) => (
  <button type="button" onClick={onClick} data-testid={testid}
    className={`chip ${active ? "chip-active" : "chip-outline"}`}>
    {label}
  </button>
);

export const Filters = ({ meta, filters, setFilter, reset, open, setOpen, activeCount }) => {
  if (!meta) return null;
  return (
    <div className="luma-card p-4 sm:p-5" data-testid="filters-panel">
      <button type="button" onClick={() => setOpen(!open)}
        data-testid="filters-toggle"
        className="w-full flex items-center justify-between">
        <span className="flex items-center gap-2 font-display font-bold luma-ink">
          <SlidersHorizontal size={18} style={{ color: "var(--luma-purple)" }} />
          Filtri
          {activeCount > 0 && (
            <span className="chip chip-active" style={{ fontSize: ".6rem" }}>{activeCount}</span>
          )}
        </span>
        <span className="label-mono luma-muted">{open ? "Nascondi" : "Mostra"}</span>
      </button>

      {open && (
        <div className="mt-5 space-y-5">
          <ChipGroup label="Canonicità" testid="filter-canonicita"
            options={meta.canonicita} value={filters.canonicita}
            onChange={(v) => setFilter("canonicita", v)} />
          <ChipGroup label="Categoria" testid="filter-categoria"
            options={meta.categorie} value={filters.categoria}
            onChange={(v) => setFilter("categoria", v)} />
          <ChipGroup label="Sottocategoria" testid="filter-sottocategoria"
            options={meta.sottocategorie} value={filters.sottocategoria}
            onChange={(v) => setFilter("sottocategoria", v)} />
          <ChipGroup label="Origine" testid="filter-origine"
            options={meta.origini} value={filters.origine}
            onChange={(v) => setFilter("origine", v)} />
          <ChipGroup label="Provenienza" testid="filter-fonte"
            options={meta.fonti} value={filters.fonte}
            onChange={(v) => setFilter("fonte", v)} />

          <div>
            <div className="label-mono luma-muted mb-2">Altri filtri</div>
            <div className="flex flex-wrap gap-1.5">
              <Toggle label="Risveglio confermato" testid="filter-risveglio"
                active={filters.risveglio_confermato === "1"}
                onClick={() => setFilter("risveglio_confermato", filters.risveglio_confermato === "1" ? "" : "1")} />
              <Toggle label="Possessore conosciuto" testid="filter-possessore-noto"
                active={filters.possessore_noto === "1"}
                onClick={() => setFilter("possessore_noto", filters.possessore_noto === "1" ? "" : "1")} />
              <Toggle label="Possessore sconosciuto" testid="filter-possessore-ignoto"
                active={filters.possessore_noto === "0"}
                onClick={() => setFilter("possessore_noto", filters.possessore_noto === "0" ? "" : "0")} />
              <Toggle label="Immagine disponibile" testid="filter-immagine"
                active={filters.con_immagine === "1"}
                onClick={() => setFilter("con_immagine", filters.con_immagine === "1" ? "" : "1")} />
            </div>
          </div>

          {activeCount > 0 && (
            <button type="button" onClick={reset} data-testid="filters-reset"
              className="pill-soft px-4 py-2 text-sm flex items-center gap-2">
              <X size={15} /> Azzera filtri
            </button>
          )}
        </div>
      )}
    </div>
  );
};
